import LegalPage, { H, LEGAL_ENTITY } from './LegalPage';

export default function Terms() {
  return (
    <LegalPage title="Пользовательское соглашение" updated="30.10.2026">
      <p>Настоящее соглашение (публичная оферта) регулирует использование сервиса adamar.app. Сервис предоставляет {LEGAL_ENTITY.name} («мы», «AdaMar»). Регистрируясь, вы принимаете эти условия. Применимое право — Кыргызская Республика.</p>

      <H>1. Что такое AdaMar</H>
      <p>AdaMar — аналитическая платформа медиа- и инфлюенсер-рынка Кыргызстана: аналитика рекламной активности (ТВ, радио, digital, Instagram), каталог авторов контента и площадка для размещения кампаний. AdaMar <b>не является стороной</b> сделок между заказчиками и авторами контента и не гарантирует их исполнение, если прямо не указано иное.</p>

      <H>2. Аккаунты и роли</H>
      <p>Роли: заказчик (компания), автор контента (креатор), администратор. Вы обязуетесь предоставлять достоверные данные и не передавать доступ третьим лицам. Подтверждение владения Instagram-аккаунтом или брендом выполняется через авторизацию Instagram или код в описании профиля; попытка присвоить чужой аккаунт — основание для блокировки.</p>

      <H>3. Данные и аналитика</H>
      <p>Аналитические показатели (охваты, вовлечённость, оценки стоимости, доли голоса) носят <b>оценочный, информационный характер</b> и не являются гарантией результатов рекламных кампаний. Данные каталога собраны из общедоступных источников и данных партнёров.</p>

      <H>4. Недопустимое использование</H>
      <p>Запрещено: автоматизированное массовое выкачивание данных сервиса; перепродажа данных без письменного согласия; попытки обхода ограничений доступа; размещение недостоверных или незаконных кампаний.</p>

      <H>5. Интеллектуальная собственность</H>
      <p>Правообладатель сервиса, его кода, дизайна и баз данных — {LEGAL_ENTITY.name}. Пользователю предоставляется ограниченная неисключительная лицензия на использование сервиса по назначению.</p>

      <H>6. Ответственность</H>
      <p>Сервис предоставляется «как есть». Мы не отвечаем за решения, принятые на основе аналитики, за действия третьих лиц (включая Instagram/Meta) и за перерывы, вызванные внешними провайдерами. Совокупная ответственность ограничена суммой, уплаченной за сервис за последние 3 месяца.</p>

      <H>7. Прекращение</H>
      <p>Вы можете удалить аккаунт в любой момент (<a href="/data-deletion" style={{ color: 'var(--accent, #4a9eff)' }}>инструкция</a>). Мы можем приостановить доступ при нарушении соглашения, уведомив вас по email.</p>

      <H>8. Изменения и контакты</H>
      <p>Мы можем обновлять соглашение, публикуя новую редакцию на этой странице. Контакты: {LEGAL_ENTITY.email}, {LEGAL_ENTITY.address}.</p>
    </LegalPage>
  );
}
